import type { NavigationData } from '@/core/types/cardNavigation.type'

export const EMPTY_NAVIGATION: NavigationData = {
  list: [],
  details: [],
  breadcrumbs: [],
  libraryData: undefined,
  classData: undefined,
}
